import * as VerticalSeparatedLayout from './src/vertical-separated-layout/index';

export { StepContainer } from './src/step-container';
export { Step } from './src/step';
export { StepsContext } from './src/steps-context';

/**
 * The "vertical separated" layout is a significant change from the previous StepContainer and Step
 * interfaces. For now, we will run both the old and the new components in parallel and unify at a
 * later date, when we can upgrade all "legacy" consumers of this package.
 */
export { VerticalSeparatedLayout };
